import ReviewService from "@/services/reviewService";
import { useQuery } from "@tanstack/react-query";

export default function useGetLatestReview() {
  const reviewService = new ReviewService();

  return useQuery({
    queryKey: ["latest-review"],
    queryFn: () => reviewService.getLatestReview(),
    retry: 1,
  });
}
